import type { ReviewClient } from "@/clients/review.client";
import type { RuntimeClient } from "@/clients/runtime.client";
import { getPlatform, isNativeApp } from "@/platform";
import { ANDROID_APP_LINK, IOS_APP_LINK } from "@/product-links";

let _runtime: RuntimeClient | undefined;
let _review: ReviewClient | undefined;

export const configureNativeCapabilities = (
  runtime: RuntimeClient,
  review: ReviewClient
): void => {
  _runtime = runtime;
  _review = review;
};

const capabilities = () => {
  if (!_runtime || !_review) {
    throw new Error("Native capabilities have not been configured");
  }
  return { runtime: _runtime, review: _review };
};

export const requestReview = async (): Promise<void> => {
  if (isNativeApp()) {
    await capabilities().review.request();
  }
};

export const shareApp = () => {
  if (getPlatform() === "android") {
    void capabilities().runtime.share({
      title: "Download 1Transcribe",
      text: "Never write notes again. Download 1Transcribe now!",
      url: ANDROID_APP_LINK,
    });
  }

  if (getPlatform() === "ios") {
    void capabilities().runtime.share({
      title: "Download 1Transcribe",
      text: "Never write notes again. Download 1Transcribe now!",
      url: IOS_APP_LINK,
    });
  }

  if (getPlatform() === "web") {
    window.open(ANDROID_APP_LINK, "_blank");
  }
};
